import { axios } from '@/services/axios';

export const getTRSRegistration = (registrationID) => {
    const endpoint = `/TRSRegistration/${registrationID}`;
    return axios.get(endpoint);
};
